import Component from '@glimmer/component';

import LoaderSvgComponent from 'webapp/components/loader-svg';
import ToolTipComponent from 'webapp/components/tool-tip';

import type DChartPrimaryPoint from 'webapp/d-chart/point/primary-point';

interface Args {
	primaryPoint: DChartPrimaryPoint | null;
	isSyncing: boolean;
	metricName: string;
	sourceInfo: string;
	attributeName: string | null;
}

export default class ClientMetricsDataComponent extends Component<Args> {
	get metricTooltip() {
		let text = this.args.metricName;

		if (this.args.attributeName) {
			text += ' / ' + this.args.attributeName;
		}

		if (this.args.sourceInfo) {
			text += ' (' + this.args.sourceInfo + ')';
		}

		return text;
	}

	get comparePoint() {
		return this.args.primaryPoint?.comparePoints[0] ?? null;
	}

	get indicatorClass() {
		if (!this.comparePoint) {
			return;
		}

		return this.comparePoint.indicatorClass;
	}
	<template>
		<div class="data {{this.indicatorClass}}">
			<div class="metric">
				<strong>{{@metricName}}</strong>{{#if @attributeName}} / {{@attributeName}}{{/if}}
				<ToolTipComponent @text={{this.metricTooltip}} @position="top" />
			</div>
			<div class="source">{{@sourceInfo}}</div>
			<div class="val">
				{{#if @isSyncing}}
					<LoaderSvgComponent />
				{{/if}}
				{{#if @primaryPoint.hasValue}}
					{{@primaryPoint.valueStr}}
				{{else}}
					-
				{{/if}}
			</div>
			{{#if this.comparePoint.changeStr}}
				<div class="change">{{this.comparePoint.changeStr}}</div>
			{{/if}}
		</div>
	</template>
}
